export default {
  //网站首页
  TotalAccount:'',                     //搜索到的总条目数
  SearchedTotal:'',                    //符合搜索条件的总条目数
  HotelList:[],                        //酒店列表
  HotelRight:[],                       //右侧广告栏推荐酒店
  HotelRightNew:[],                    //新增酒店
  HotelOther:[],                       //热门酒店
  BrandInfo:{},                        //品牌馆详情
  //酒店活动页面
  ActivityList:[],                     //酒店活动列表
  ExpiredActivity:'',                  //已过期活动
  UnderwayActivity:'',                 //正在进行的活动
  TotalActivity:'',                    //正在进行的活动
  //获取酒店、民宿、景区首字母
  SearchInitialList:[],                //根据首字母进行搜索
  //酒店、民宿、景区详情
  DisplayBasicInfo:{},                 //基本信息
  DisplayRoomType:[],                  //酒店房型信息
  DisplayCalendarInfo:{},              //日历信息
  DisplayCommentInfo:{},               //评论信息
  DisplayMeetInfo:{},                  //会议室信息
  DisplayActiInfo:{},                   //活动信息
  DisplayRaryInfo:{},                   //套餐信息
  DisplayRestaurantInfo:{},             //餐饮信息
  DisplayRangeInfo:{},                 //周围酒店信息
  DisplayRoomInfo:{},                  //房型信息
  DisplayHomestayInfo:[],              //民宿活动信息
  DisplayShopCart:{},                  //加入购物车的预订起止时间
  DisplayRangeHotel:[],                //酒店详情页-》附近酒店
  DisplayNearHotHotel:[],              //景区详情页-》附近热门酒店
  DisplayNearHotHomestay:[],           //景区详情页-》附近热门民宿
  DisplayPeerHotel:[],                 //景区详情页-》同级别的酒店
  DisplayScenicTicket:[],              //景区门票
  CommentsListByRate:[],               //获取不同等级的评论
  CommentTotalNum:0,                   //获取不同等级的评论数量
  //酒店活动详情
  GetActivityInfo:[],                   //获取酒店活动详情
  //民宿购物车
  ShopTargetInfo:[],                    //民宿房间或活动简介
  ShopRoomArr:[],                       //民宿房型详情
  ShopActisArr:[],                      //民宿活动详情
  ShopNewPrice:'',                      //民宿房型、活动更新后的价格
  ShopTravelInfo:[],                    //采购商信息
  StayNightInfo:'',                     //预订天数信息
  //首页搜索框信息
  BlockConditionList:null,              //获取行政区划信息
  //景区购物车
  ScenicTicketsOpt:[],                  //获取其他可供选择的景区门票
  RouterId:'',                          //提交成功后的跳转散客ID
  //地图信息
  MapBasicInfo:[],                      //地图页面展示的基本信息
  TopOfTheTown:[],                      //搜索面板热门城市
  CityByInitial:[],                     //按首字母归类的城市列表
}
